module.exports = __webpack_public_path__ + "img/discover.989470bd.svg";